// Generated by ts-to-zod
import { z } from 'zod';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const configurationChangelogListQuerySchema = paginationQuerySchema.and(
  z.object({
    objectType: z.array(z.string()).optional(),
    objectId: z.array(z.number()).optional(),
    versionEvent: z.array(z.string()).optional(),
    modifierId: z.array(z.number()).optional(),
    changedFields: z.string().optional(),
    versionCreatedAtAfter: z.string().optional(),
    versionCreatedAtBefore: z.string().optional(),
    versionId: z.array(z.number()).optional(),
    versionIdRangeMin: z.number().optional(),
    versionIdRangeMax: z.number().optional(),
    includeSnapshot: z.boolean().optional(),
    q: z.string().optional(),
  })
);
